import { createAction } from '@reduxjs/toolkit';

import { ACTIONS } from 'js/src/data/thumbnail-previews/thumbnail-previews-types';

export const storeLuminaryThumbnail = createAction<{
    id: number | string;
    image: HTMLCanvasElement;
}>(ACTIONS.STORE_LUMINARY_THUMBNAIL);

export const clearLuminaryThumbnail = createAction<{
    id: number | string;
}>(ACTIONS.CLEAR_LUMINARY_THUMBNAIL);
